import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { Margin } from 'recharts/types/util/types';

import { getNumberFormatter } from '@/utils/getNumberFormatter';

import type { ChartData } from '../types/chart';
import { TickLabel } from './tick-label';
import { TooltipContent } from './tooltip-content';

export const HouseHoldIncomeAgeCharts = ({
  chartData,
  height,
  fontSize,
  barSize,
  margin,
}: {
  chartData: ChartData;
  height: number;
  fontSize?: number;
  barSize?: number;
  margin?: Margin;
}) => {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart layout="vertical" data={chartData} margin={margin}>
        <XAxis type="number" domain={[0, 100]} hide={true} />
        <YAxis
          dataKey="title"
          type="category"
          axisLine={false}
          tickLine={false}
          interval={0}
          tick={({ x, y, payload }) => (
            <TickLabel
              x={x - 10}
              y={y + 5}
              textAnchor="end"
              fontSize={fontSize}
              value={payload.value}
            />
          )}
        />
        <YAxis
          yAxisId="right"
          orientation="right"
          type="category"
          dataKey="value"
          axisLine={false}
          tickLine={false}
          fontSize={fontSize}
          interval={0}
          tickFormatter={(val) => `${val.toFixed(2)}%`}
        />
        <Tooltip
          cursor={false}
          content={({ active, payload }) => (
            <TooltipContent active={active} payload={payload}>
              {(item) => (
                <div className="mt-1">
                  <p className="text-[16px] font-normal">
                    {getNumberFormatter(Number(item.absoluteValue), 'en-GB', {
                      maximumFractionDigits: 0,
                      minimumFractionDigits: 0,
                    })}
                  </p>
                </div>
              )}
            </TooltipContent>
          )}
        />
        <Bar
          dataKey="value"
          fill="#A0A0A0"
          radius={20}
          barSize={barSize}
          background={{
            fill: '#D9D9D9',
            radius: 20,
          }}
          activeBar={{
            fill: 'hsl(var(--chart-6))',
          }}
          isAnimationActive={false}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};
